import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { mergeStyleSets, Panel, PanelType } from '@fluentui/react';
const contentStyles = mergeStyleSets({
    body: {
        flex: '4 4 auto',
        overflowY: 'hidden',
        padding: '0 24px 24px 24px',
        selectors: {
            p: {
                margin: '14px 0'
            },
            'p:first-child': {
                marginTop: 0
            },
            'p:last-child': {
                marginBottom: 0
            }
        }
    },
    container: {
        alignItems: 'stretch',
        display: 'flex',
        flexFlow: 'column nowrap',
        minWidth: '360px',
        minHeight: '700px'
    },
    internalMain: {
        main: {
            boxShadow: 'rgb(0 0 0 / 50%) 0px 0px 30px 0px'
        }
    }
});
export const AddEditView = ({ children, dismiss, context })=>{
    const panelProps = React.useMemo(()=>/*#__PURE__*/ _jsx(Panel, {
            isOpen: true,
            type: PanelType.medium,
            onDismiss: dismiss,
            closeButtonAriaLabel: context.loc('Close', 'Close'),
            className: contentStyles.internalMain,
            children: /*#__PURE__*/ _jsx("div", {
                className: contentStyles.body,
                children: children
            })
        }), [
        children,
        dismiss,
        context
    ]);
    return panelProps;
};
export default AddEditView;
